import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=22821c6c&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailDialog.vue?vue&type=style&index=0&id=22821c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22821c6c",
  null
  
)

export default component.exports